var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPolygon = function SvgPolygon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 9 7",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.933 6.25a.5.5 0 0 1-.866 0L1.036 1a.5.5 0 0 1 .433-.75H7.53a.5.5 0 0 1 .433.75L4.933 6.25Z",
    fill: "currentColor"
  })));
};
export { SvgPolygon as ReactComponent };